import React, { Component } from "react";
import oops from "../img/oops.png";

export class ErrorBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      error: "",
      errorInfo: "",
    };
  }
  static getDerivedStateFromError = (error) => ({ hasError: true });
  componentDidCatch = (err, info) =>
    this.setState({ error: err, errorInfo: info });
  render() {
    if (this.state.hasError)
      return (
        <div
          className="p-3"
          style={{ width: window.innerWidth, height: window.innerHeight }}
        >
          <div className="w-100 d-flex mb-3">
            <img
              src={oops}
              alt=""
              className="mx-auto"
              width={
                (window.innerHeight < window.innerWidth
                  ? window.innerHeight
                  : window.innerWidth) * 0.5
              }
              height={
                (window.innerHeight < window.innerWidth
                  ? window.innerHeight
                  : window.innerWidth) * 0.5
              }
            />
          </div>
          <h1 className="text-danger fs-lg">Oh No!!</h1>
          <h6 className="px-2">
            It seems something went wrong while loading this page.
          </h6>

          <br />

          <h1 className="text-orange">What Should I Do ?</h1>
          <ul>
            <div className="py-1"></div>
            <li>
              <div>
                <h5 className="text-decoration-underline text-primary lh-sm mb-0">
                  Refresh Page
                </h5>
                <div className="lh-sm">Try Refreshing this page.</div>
              </div>
            </li>
            <div className="py-2"></div>
            <li>
              <h5 className="text-decoration-underline text-warning lh-sm mb-0">
                Report Issue
              </h5>
              <div className="lh-sm">
                Help us improve user experience by reporting this issue.
              </div>
            </li>
            <div className="py-2"></div>
            <li>
              <h5 className="text-decoration-underline text-success lh-sm mb-0">
                Contact Support
              </h5>
              <div className="lh-sm">
                If problem still continues, contact team Gowholsale.
              </div>
            </li>
          </ul>
        </div>
      );
    return this.props.children;
  }
}

export default ErrorBox;
